import React from 'react'

function SecureFirewall({ width, height }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 48 48">
      <g data-name="Safe and secure transactions" transform="translate(-.167)">
        <path fill="none" d="M0 0h48v48H0z" data-name="Path 6" transform="translate(.167)" />
        <path
          fill="#24397a"
          stroke="#fff"
          strokeWidth="1.3"
          d="M41.198 10.207L26.11 3.8a3.642 3.642 0 00-1.449-.3 3.641 3.641 0 00-1.449.3L8.125 10.207a3.84 3.84 0 00-2.328 3.543c0 20.616 14.886 30.75 18.85 30.75 3.871 0 18.864-9.981 18.864-30.75a3.847 3.847 0 00-2.313-3.543zM24.656 40.656C16.995 37.4 9.569 27.3 9.569 13.75l15.087-6.406 15.091 6.406c0 13.914-7.734 23.783-15.091 26.906zm-4.324-17.375a1.862 1.862 0 00-1.333-.563 1.9 1.9 0 00-1.886 1.922 1.934 1.934 0 00.553 1.359l3.771 3.843a1.871 1.871 0 001.333.563 1.881 1.881 0 001.432-.671l7.545-8.968a1.937 1.937 0 00.454-1.251 1.919 1.919 0 00-1.884-1.921 1.87 1.87 0 00-1.433.67l-6.218 7.395z"
          data-name="Path 2245"
        />
      </g>
    </svg>
  )
}

export default SecureFirewall
